<template>
  <b-card title="View Sparepart">
    <b-row>
      <b-col cols="12" class="text-center mb-3">
        <b-img :src="form.image || noImageURL" fluid rounded style="width: 150px; height: 150px; object-fit: cover;"></b-img>
      </b-col>
      <b-col cols="12">
        <b-form @submit.prevent="">
          <b-form-group id="model" label="Model" label-for="model" description="Item Model">
            <b-form-input disabled id="input-model" v-model="form.itemModel" type="text" placeholder="Enter item model" required></b-form-input>
          </b-form-group>

          <b-form-group id="description" label="Description" label-for="description" description="Description">
            <b-form-input disabled id="input-description" v-model="form.description" type="text" placeholder="Enter description" required></b-form-input>
          </b-form-group>

          <b-form-group label="Product Hierarchy" description="Product Hierarchy">
            <b-form-input disabled id="input-productHierarchy" v-model="form.productHierarchy" type="text" placeholder="Enter Hierarchy"></b-form-input>
          </b-form-group>

          <b-form-group label="Location" description="Location">
            <b-form-input disabled id="input-location" v-model="form.location" type="text" placeholder="Enter Location"></b-form-input>
          </b-form-group>

          <b-form-group label="Category" label-for="category" description="Category">
            <v-select 
              id="category" 
              v-model="selectedCategory" 
              :options="categoryOptions" 
              label="text"  
              multiple
              @input="categorySelected"
              disabled
            />
          </b-form-group>

          <b-form-group label="Replacement Item" label-for="replacement-item" description="Replacement Item">
            <v-select
              id="replacement-item"
              v-model="selectedReplacement"
              :options="replacementOptions"
              label="text"
              multiple
              @input="replacementSelected"
              disabled
            ></v-select>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { mapActions } from 'vuex';
import axios from '@/axios';
import vSelect from "vue-select";
export default {
  components: {
    "v-select": vSelect
  },
  data() {
    return {
      form: {},
      newImage: null,
      noImageURL: require('@/assets/images/no-image.png'),
      category: null,
      categoryOptions: [],
      selectedCategory: [],
      selectedReplacement: [],
      replacementOptions: []
    };
  },
  mounted() {
    this.getItemDetail();
  },
  computed: {},
  methods: {
    ...mapActions({}),
    getItemDetail() {
      axios.get(`sales-and-purchase/drcc/item/detail/${this.$route.params.id}`).then((response) => {
        let item = response.data.data;
        item.status = item.status === '' ? 'Active' : 'Inactive';
        this.form = item;
        const product = item.productHierarchy;
        console.log("🚀 ~ axios.get ~ item:", item)
        
        if (product.includes('05100')) {
          if (item.categorySparepart.length > 0) {
            // this.categoryOptions = item.categorySparepart.map((item) => item.name)
            this.selectedCategory = item.categorySparepart.map((item) => {
              return { text: item.name, value: item.id }
            })
          }
          this.category = 'sparepart'
          if (item.replacementItem.length > 0) {
            this.selectedReplacement = item.replacementItem.map((item) => {
              return { text: item.itemModel, value: item._id }
            })
          }
        }else if (product.includes('10000')) {
          if (item.categoryAccessories.length > 0) {
            // this.categoryOptions = item.categoryAccessories.map((item) => item.name)
            this.selectedCategory = item.categoryAccessories.map((item) => {
              return { text: item.name, value: item.id }
            })
          }
          this.category = 'accessories'
        }
      }).catch((e) => {
        console.log(e);
      });
    },
    categorySelected(values) {
      this.selectedCategory = values.map(v => {
        return { text: v.text, value: v.value };
      });
    },
    replacementSelected(values) {
      this.selectedReplacement = values.map(v => {
        return { text: v.text, value: v.value };
      });
    },
  }
};
</script>